module.exports = __webpack_public_path__ + "img/home_01_vertical.09ac5cac.jpg";